import { translate } from '../../i18n'
import Axios from 'axios'

const PropertyModule = {
  namespaced: true,
  state: {
    colombo: {
      location: 'CASAMIA Colombo @ on Three20',
      title: 'Casamia Colombo',
      about_title: 'Homewind Leisures',
      description: 'Lorem ipsum dolor sit amet, ratione lacus ligula, massa justo\n' +
        '            vel,\n' +
        '            phasellus at, erat et dui\n' +
        '            maecenas magna mauris fusce, sit mollis. Amet imperdiet pellentesque diam turpis eu nisl, felis\n' +
        '            nibh nunc donec semper aliquam, sem elit vel mollis eget, enim non tortor varius et autem,\n' +
        '            senectus iaculis tincidunt cursus ut proin inceptos. Pede inceptos ut vehicula dictum ipsa, ante\n' +
        '            libero in cursus a senectus. Facilisis tincidunt, auctor aptent fringilla eu nunc torquent\n' +
        '            et.',
      bannerUrl: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/banner.jpg`,
      slideItems: [
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_1.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_2.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_3.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_4.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_5.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_6.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_7.jpg` }
      ],
      embeddedMapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.7610380697106!2d79.85669391477292!3d6.919145995000678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae259895a6fafb7%3A0xfac07ea1a26cac1!2sCASAMIA%20Colombo%20%40%20On%20Three20!5e0!3m2!1sen!2slk!4v1579427423347!5m2!1sen!2slk',
      thumbNavItems: [
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_8.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_9.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_10.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_11.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_12.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_13.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_14.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/prop_15.jpg` }
      ],
      packages: [
        {
          id: 'colombo',
          section_id: 'rates_and_offers',
          url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/packages/package_1.jpg`,
          title: translate('colombo.explore_more.item_1.title'),
          description: translate('colombo.explore_more.item_1.description'),
          prices: [],
          deals: []
        },
        {
          id: 'colombo',
          section_id: 'food_and_beverage',
          url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/packages/package_2.jpg`,
          title: translate('colombo.explore_more.item_2.title'),
          description: translate('colombo.explore_more.item_2.description'),
          items: []
        },
        {
          id: 'colombo',
          section_id: 'excursions',
          url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-colombo/packages/package_3.jpg`,
          title: translate('colombo.explore_more.item_3.title'),
          description: translate('colombo.explore_more.item_3.description')
        }
      ],
      features: [
        {
          icon: 'icon: bolt; ratio: 1.5',
          feature: translate('colombo.features.feature_1.title'),
          description: translate('colombo.features.feature_1.description')
        },
        {
          icon: 'icon: home; ratio: 1.5',
          feature: translate('colombo.features.feature_2.title'),
          description: translate('colombo.features.feature_2.description')
        },
        {
          icon: 'icon: world; ratio: 1.5',
          feature: translate('colombo.features.feature_3.title'),
          description: translate('colombo.features.feature_3.description')
        },
        {
          icon: 'icon: heart; ratio: 1.5',
          feature: translate('colombo.features.feature_4.title'),
          description: translate('colombo.features.feature_4.description')
        },
        {
          icon: 'icon: happy; ratio: 1.5',
          feature: translate('colombo.features.feature_5.title'),
          description: translate('colombo.features.feature_5.description')
        },
        {
          icon: 'icon: lifesaver; ratio: 1.5',
          feature: translate('colombo.features.feature_6.title'),
          description: translate('colombo.features.feature_6.description')
        }
      ],
      testimonials: [
        {
          user: 'Kara',
          country: 'Australia',
          description: 'The Apartment is superb and stylish. It has everything you need. The building has a swimming pool that is really nice, clean and well maintained. The location is excellent, close to all the main distinctions in Colombo. This will be my first choice for accommodation if I am in Colombo again.'
        },
        {
          user: 'Sami',
          country: 'United Kingdom',
          description: 'Great Location and very close to everything!'
        }
      ]
    },
    nilaveli: {
      location: 'CASAMIA Nilaveli',
      title: 'Casamia Nilaveli',
      bannerUrl: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/banner.jpg`,
      slideItems: [
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/slider/prop_1.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/slider/prop_2.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/slider/prop_3.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/slider/prop_4.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/slider/prop_5.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/slider/prop_6.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/slider/prop_7.jpg` }
      ],
      embeddedMapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3944.0965891443257!2d81.19778801427476!3d8.682364496713413!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3afbbf8e24a447e7%3A0x5d9b9b9ffc3bbf39!2sCASAMIA+Oceanfront+Condo+Nilaveli!5e0!3m2!1sen!2slk!4v1560607423375!5m2!1sen!2slk',
      thumbNavItems: [
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/thumb-slider/prop_1.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/thumb-slider/prop_2.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/thumb-slider/prop_3.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/thumb-slider/prop_4.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/thumb-slider/prop_5.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/thumb-slider/prop_6.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/thumb-slider/prop_7.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/thumb-slider/prop_8.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/thumb-slider/prop_9.jpg` }
      ],
      packages: [
        {
          id: 'nilaveli',
          section_id: 'rates_and_offers',
          url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/packages/package_1.jpg`,
          title: translate('nilaveli.explore_more.item_1.title'),
          description: translate('nilaveli.explore_more.item_1.description'),
          prices: [],
          deals: []
        },
        {
          id: 'nilaveli',
          section_id: 'food_and_beverage',
          url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/packages/package_2.jpg`,
          title: translate('nilaveli.explore_more.item_2.title'),
          description: translate('nilaveli.explore_more.item_2.description'),
          items: []
        },
        {
          id: 'nilaveli',
          section_id: 'excursions',
          url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/packages/package_3.jpg`,
          title: translate('nilaveli.explore_more.item_3.title'),
          description: translate('nilaveli.explore_more.item_3.description')
        }
      ],
      features: [
        {
          icon: 'icon: bolt; ratio: 1.5',
          feature: translate('nilaveli.features.feature_1.title'),
          description: translate('nilaveli.features.feature_1.description')
        },
        {
          icon: 'icon: home; ratio: 1.5',
          feature: translate('nilaveli.features.feature_2.title'),
          description: translate('nilaveli.features.feature_2.description')
        },
        {
          icon: 'icon: world; ratio: 1.5',
          feature: translate('nilaveli.features.feature_3.title'),
          description: translate('nilaveli.features.feature_3.description')
        },
        {
          icon: 'icon: heart; ratio: 1.5',
          feature: translate('nilaveli.features.feature_4.title'),
          description: translate('nilaveli.features.feature_4.description')
        },
        {
          icon: 'icon: happy; ratio: 1.5',
          feature: translate('nilaveli.features.feature_5.title'),
          description: translate('nilaveli.features.feature_5.description')
        },
        {
          icon: 'icon: lifesaver; ratio: 1.5',
          feature: translate('nilaveli.features.feature_6.title'),
          description: translate('nilaveli.features.feature_6.description')
        }
      ],
      testimonials: [
        {
          user: 'Alyssa',
          country: 'Australia',
          description: 'The 3 bedroom condo is very clean and all the furnishings/appliances are all new and great condition. The views are fantastic. close to the pool and the beach. we\'d likely stay here again.'
        },
        {
          user: 'Danielle',
          country: 'Australia',
          description: 'From first arrival our stay was greeted with smiling faces. Everyone was very obliging to help where ever they could and the apartment was lovely with all the special touches making you feel right at home.'
        },
        {
          user: 'Laura Crosato',
          country: 'Italy',
          description: 'Stunning sea view, clean and comfortable. Excellent security staff. The garden directly overlooks the beautiful beach in front of Pigeon Island. Apartment with modern furnishings equipped with every comfort. I would go there again!'
        },
        {
          user: 'Nicolia Nanayakkara',
          country: 'Sri Lanka',
          description: 'So clean. Place was so good we could relax very well. loved it'
        },
        {
          user: 'Lorenzo',
          country: 'Italy',
          description: 'Clean spacious new deluxe apartment 20 metres from the sea where you can enjoy good food in a great atmosphere.'
        }
      ]
    },
    turtle: {
      location: 'Tangalle',
      title: 'Tutle Nest Rekawa',
      description: 'Lorem ipsum dolor sit amet, ratione lacus ligula, massa justo\n' +
        '            vel,\n' +
        '            phasellus at, erat et dui\n' +
        '            maecenas magna mauris fusce, sit mollis. Amet imperdiet pellentesque diam turpis eu nisl, felis\n' +
        '            nibh nunc donec semper aliquam, sem elit vel mollis eget, enim non tortor varius et autem,\n' +
        '            senectus iaculis tincidunt cursus ut proin inceptos. Pede inceptos ut vehicula dictum ipsa, ante\n' +
        '            libero in cursus a senectus. Facilisis tincidunt, auctor aptent fringilla eu nunc torquent\n' +
        '            et.',
      bannerUrl: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/turtle-nest/banner.jpg`,
      slideItems: [
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/turtle-nest/prop_6.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/turtle-nest/prop_7.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/turtle-nest/prop_8.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/prop_10.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/prop_2.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/prop_3.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/prop_4.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/prop_5.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/prop_1.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/prop_7.jpg` }
      ],
      embeddedMapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3967.6221598478323!2d80.84484261401471!3d6.046464995621114!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae6b4f11b5a8565%3A0x6628f0cb78426feb!2sThe+Turtle+Nest!5e0!3m2!1sen!2slk!4v1560706290236!5m2!1sen!2slk',
      thumbNavItems: [
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/turtle-nest/prop_9.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/turtle-nest/prop_10.jpg` },
        { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/turtle-nest/prop_11.jpg` }
      ],
      packages: [
        {
          id: 'rekawa',
          section_id: 'rates_and_offers',
          url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/packages/package_3.jpg`,
          title: translate('turtle_nest.explore_more.item_1.title'),
          description: translate('turtle_nest.explore_more.item_1.description'),
          prices: [],
          deals: []
        },
        {
          id: 'rekawa',
          section_id: 'food_and_beverage',
          url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/packages/package_2.jpg`,
          title: translate('turtle_nest.explore_more.item_2.title'),
          description: translate('turtle_nest.explore_more.item_2.description'),
          items: []
        },
        {
          id: 'rekawa',
          section_id: 'excursions',
          url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/properties/casamia-nilaveli/packages/package_1.jpg`,
          title: translate('turtle_nest.explore_more.item_3.title'),
          description: translate('turtle_nest.explore_more.item_3.description')
        }
      ],
      features: [
        {
          icon: 'icon: bolt; ratio: 1.5',
          feature: 'ROOM AMENITIES',
          description: 'King size beds, en-suite bathrooms, in-room safes, A/C, overhead fans, cable TV, hot/cold rain showers, hair dryers'
        },
        {
          icon: 'icon: home; ratio: 1.5',
          feature: 'DAILY HOUSEKEEPING',
          description: 'Enjoy having your room attended to every day if you choose'
        },
        {
          icon: 'icon: world; ratio: 1.5',
          feature: 'FREE WIFI',
          description: 'Stay connected to your colleagues and loved ones back home'
        },
        {
          icon: 'icon: video-camera; ratio: 1.5',
          feature: 'FULLY SERVICED PROPERTY',
          description: 'Staff in residence at all times'
        },
        {
          icon: 'icon: lifesaver; ratio: 1.5',
          feature: 'AIRPORT TRANSFERS/ TAXI SERVICE',
          description: 'Lake Lodge staff can help you organise your transport needs'
        },
        {
          icon: 'icon: happy; ratio: 1.5',
          feature: 'BAR & DINING',
          description: 'Food we are renowned for and a licensed bar'
        }
      ]
    },
    propertyKeys: {
      1: 'nilaveli',
      2: 'colombo',
      3: 'turtle'
    }
  },
  mutations: {
    setPriceList (state, { propertyId, priceList }) {
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      const priceModal = []
      months.forEach((key, index) => {
        priceModal.push({
          month: key,
          single: parseFloat(priceList[0][index]) > 0 ? `${parseFloat(priceList[0][index])}/=` : '-',
          double: parseFloat(priceList[1][index]) > 0 ? `${parseFloat(priceList[1][index])}/=` : '-',
          triple: parseFloat(priceList[2][index]) > 0 ? `${parseFloat(priceList[2][index])}/=` : '-',
          quad: parseFloat(priceList[3][index]) > 0 ? `${parseFloat(priceList[3][index])}/=` : '-'
        })
      })
      state[state.propertyKeys[propertyId]].packages[0].prices = priceModal
    },
    setDealItems (state, { propertyId, deals }) {
      state[state.propertyKeys[propertyId]].packages[0].deals = deals
    },
    setFoodItems (state, { propertyId, foods }) {
      state[state.propertyKeys[propertyId]].packages[1].items = foods
    }
  },
  actions: {
    async fetchPropertyPriceList ({ commit }, { propertyId }) {
      try {
        const res = await Axios.get(`/property/${propertyId}/priceList`)
        if (res) {
          commit('setPriceList', { propertyId, priceList: JSON.parse(res.data.price_list) })
        }
      } catch (e) {
        commit('setPriceList', { propertyId, priceList: [] })
        throw e
      }
    },
    async fetchPropertyDeals ({ commit }, { propertyId }) {
      try {
        const res = await Axios.get(`/property/${propertyId}/deals`)
        if (res) {
          commit('setDealItems', { propertyId, deals: res.data })
        }
      } catch (e) {
        commit('setDealItems', { propertyId, deals: [] })
        throw e
      }
    },
    async fetchPropertyFoods ({ commit }, { propertyId }) {
      try {
        const res = await Axios.get(`/property/${propertyId}/foods`)
        if (res) {
          commit('setFoodItems', { propertyId, foods: res.data })
        }
      } catch (e) {
        commit('setFoodItems', { propertyId, foods: [] })
        throw e
      }
    }
  },
  getters: {}
}

export default PropertyModule
